/**
 * Executes a callback function immediately if the DOM is fully loaded,
 * or as soon as the DOM content is loaded if it's not ready yet.
 *
 * @param {Function} callback - The function to execute when the DOM is ready.
 */
export function onDomContentLoaded(callback) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
}
